export default function RiskManagementDirective() {
  return {
    template: require('./risk-management.html'),
    scope: {
      customerId: '=',
      rmmReportingSource: '=',
      assessmentId: '=',
      assessmentPermissions: '<',
      status: '=',
      includeSchematics: '=',
      includeKeyContacts: '=',
      assessmentFacilities: '=',
      assessmentItCoreProcedures: '=',
      includePandemicPolicy: '=',
      includeEmergencyPlan: '=',
    },
    controller: 'RiskManagementController',
    controllerAs: 'riskManagementVM',
    bindToController: true,
    replace: true,
  };
}
